import React, { useEffect, useState } from 'react';
import { PillTabBar } from './TabBars';

/**
 * TabNavigation - Componente de navegación por pestañas reutilizable
 *
 * @param {Object} props
 * @param {Array} props.tabs - Array de objetos con { key, label, icon, content }
 * @param {string} props.defaultTab - Key del tab por defecto
 * @param {boolean} props.isDarkMode - Modo oscuro
 * @param {Object} props.style - Estilos adicionales para la barra de tabs
 * @param {Object} props.contentStyle - Estilos adicionales para el contenedor del contenido
 */
const TabNavigation = ({
  tabs = [],
  defaultTab = null,
  isDarkMode = false,
  className = '',
  style = {},
  contentStyle = {},
  ...props
}) => {
  const initialKey = defaultTab || (tabs.length > 0 ? tabs[0].key : null);
  const [activeTab, setActiveTab] = useState(initialKey);
  void isDarkMode;

  useEffect(() => {
    if (!defaultTab) return;
    if (!tabs.some((t) => t.key === defaultTab)) return;
    setActiveTab(defaultTab);
  }, [defaultTab]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (activeTab && tabs.some((t) => t.key === activeTab)) return;
    const fallback = defaultTab || (tabs.length > 0 ? tabs[0].key : null);
    if (fallback) setActiveTab(fallback);
  }, [tabs, activeTab, defaultTab]);

  const activeTabContent = tabs.find(tab => tab.key === activeTab)?.content || null;

  return (
    <div className={className} {...props}>
      <PillTabBar
        items={tabs}
        activeKey={activeTab}
        onChange={setActiveTab}
        style={{ marginBottom: 16, ...style }}
      />

      {activeTabContent ? (
        <div style={{ marginTop: 8, ...contentStyle }}>
          {activeTabContent}
        </div>
      ) : null}
    </div>
  );
};

export default TabNavigation;